export default "__VITE_ASSET__88adf1f8__"